import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../common/IconButton';

const Part = ({ category, icon, selectedOption }) => {
  return (
    <div className="part">
      <IconButton
        isBackgroundImage={category === 'baseColor' || category === 'finish'}
        icon={icon}
        size="large"
        backgroundColor="#b7b7b7"
        iconColor="#000"
      />
      <div className="part_container">
        <div className="part_title">{category}</div>
        <div className="part_subtitle">{selectedOption}</div>
      </div>
    </div>
  );
};

Part.propTypes = {
  category: PropTypes.string,
  icon: PropTypes.string,
  selectedOption: PropTypes.string
};

export default Part;
